import { render, staticRenderFns } from "./sub_notice1.vue?vue&type=template&id=8557c2bc&scoped=true&"
import script from "./sub_notice1.vue?vue&type=script&lang=js&"
export * from "./sub_notice1.vue?vue&type=script&lang=js&"
import style0 from "./sub_notice1.vue?vue&type=style&index=0&id=8557c2bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8557c2bc",
  null
  
)

export default component.exports